import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const consentIntegrationCheck = async (domain: string, integration: 'mailchimp' | 'klaviyo' | 'flashy'): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/validate-integration-key/${integration}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}